import { useMutation } from '@tanstack/react-query';
import type { JobSourceServiceType } from '@/types/serializers';

type JobSourcePostRequest = {
  source_type?: string;
  service_type?: 'normal' | 'database';
  login_id?: string;
  login_pass?: string;
  access_url?: string;
  basic_auth_id?: string;
  basic_auth_pass?: string;
  urls?: string | string[];
  url?: string;
  target_type?: string;
  target_value?: string;
};

export default function usePostJobSources() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async ({
      source_type,
      service_type,
      login_id,
      login_pass,
      access_url,
      basic_auth_id,
      basic_auth_pass,
      urls,
      url,
      target_type,
      target_value,
    }: JobSourcePostRequest): Promise<{ id: number; service_type: JobSourceServiceType }> => {
      const response = await fetch(`/agent/api/job_sources`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          source_type,
          service_type,
          login_id,
          login_pass,
          access_url,
          basic_auth_id,
          basic_auth_pass,
          urls,
          url,
          target_type,
          target_value,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error(errorData);
        throw new Error(errorData?.error || '作成に失敗しました');
      }

      const data = await response.json();
      return data;
    },
  });
}
